import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

function LoginSelect() {
  const navigate = useNavigate();

  return(
    <div className="flex flex-col items-center justify-between h-[100vh]">

      <button className="bg-[#f5f5f5] rounded-lg p-2 py-3 self-start m-10"
      onClick={(e) => {
        e.preventDefault();
        navigate("/");
      }}><ArrowBackIosIcon sx={{ marginLeft: '8px' }}/></button>

<div className="flex flex-col w-[100%] justify-between h-[30vh]">

      <button className="bg-[color:--primary-color] hover:bg-[color:--primary-color-hover] active:bg-[color:--primary-color-active] text-white font-bold rounded-full py-3 m-auto w-72 lg:w-96"
      onClick={(e) => {
        e.preventDefault();
        navigate("/login");
      }}>Cliente</button>

      <button className="bg-[color:--primary-color] hover:bg-[color:--primary-color-hover] active:bg-[color:--primary-color-active] text-white font-bold rounded-full py-3 m-auto w-72 lg:w-96"
    onClick={(e) => {
      e.preventDefault();
      navigate("/login");
    }}>Administrador</button>

      </div>

      <div className="footer-bg mt-16"></div>
    </div>
  )
}

export default LoginSelect;